import { createRecipe } from './runtime.js';

const srOnlyConfig = {"name":"srOnly"}

export const srOnly = /* @__PURE__ */ createRecipe(srOnlyConfig)